export const DEFAULT_SHERBERT_BASE_URL = 'https://api.sherbert.cimpress.io';
export const UPLOADS_BASE_URL = 'https://uploads.documents.cimpress.io/v1/uploads';
export const SHERBERT_V3_UPLOAD_URL = 'https://api.sherbert.cimpress.io/v3/uploads';
export const SHERBERT_ASSETS_API_URL_V3 = 'https://api.sherbert.cimpress.io/v3/assets';
export const SHERBERT_ASSETS_API_URL_V2 = 'https://api.sherbert.cimpress.io/v2/assets';
//# sourceMappingURL=baseUrl.js.map